/* ── RR Color Variant Swatches — PLP card swap + expand/collapse ── */
(function () {
  'use strict';

  /* Strip any HTML tags from a string — returns plain text */
  function stripHTML(str) {
    if (!str) return '';
    return str.replace(/<[^>]*>/g, '').trim();
  }

  /**
   * Parse a price string — handles "Rs. 4 619/-", "₹1,759", "Rs.4619" etc.
   * Returns a numeric value, or NaN if unparseable.
   */
  function parsePrice(str) {
    if (!str) return NaN;
    var cleaned = str.replace(/[Rs.₹\s,\/-]/gi, '');
    return parseFloat(cleaned);
  }

  /**
   * Format a number as Indian rupee string: ₹2,399
   */
  function formatINR(num) {
    if (isNaN(num)) return '';
    return '₹' + Math.round(num).toLocaleString('en-IN');
  }

  /**
   * Calculate discount % between compare (MRP) and selling price.
   * Returns a string like "30%" or empty string if not applicable.
   */
  function calcDiscount(priceStr, compareStr) {
    var sp  = parsePrice(priceStr);
    var mrp = parsePrice(compareStr);
    if (isNaN(sp) || isNaN(mrp) || mrp <= 0 || sp >= mrp) return '';
    var pct = Math.round(((mrp - sp) / mrp) * 100);
    return pct > 0 ? pct + '%' : '';
  }

  /* Hide native Impulse PLP color swatches immediately */
  function hideNativeSwatches() {
    document.querySelectorAll('.grid-product__colors').forEach(function(el) {
      el.style.display = 'none';
    });
  }
  hideNativeSwatches();
  if (window.MutationObserver) {
    new MutationObserver(hideNativeSwatches).observe(document.body, { childList: true, subtree: true });
  }

  function findCardEl(swatchEl) {
    var el = swatchEl;
    while (el && el.parentElement) {
      el = el.parentElement;
      if (el.classList && el.classList.contains('grid__item')) return el;
    }
    return null;
  }

  function updateCard(card, data) {
    /* Primary image */
    var img = card.querySelector('.grid-product__image, .grid__image-ratio img, .image-wrap img');
    if (img && data.img) {
      img.src = data.img;
      img.srcset = '';
    }

    /* Hover image */
    var hoverImg = card.querySelector('.grid-product__secondary-image img');
    if (hoverImg) {
      if (data.imgHover) {
        hoverImg.src = data.imgHover;
        hoverImg.srcset = '';
        hoverImg.closest('.grid-product__secondary-image').style.display = '';
      } else {
        hoverImg.closest('.grid-product__secondary-image').style.display = 'none';
      }
    }

    /* Title */
    var title = card.querySelector('.grid-product__title');
    if (title && data.title) title.textContent = stripHTML(data.title);

    /* Parse raw price values */
    var cleanPrice   = stripHTML(data.price);
    var cleanCompare = stripHTML(data.compare);
    var spNum  = parsePrice(cleanPrice);
    var mrpNum = parsePrice(cleanCompare);

    /* Format to ₹x,xxx */
    var formattedSP  = isNaN(spNum)  ? cleanPrice  : formatINR(spNum);
    var formattedMRP = isNaN(mrpNum) ? cleanCompare : formatINR(mrpNum);

    var priceWrap = card.querySelector('.grid-product__price');
    if (priceWrap) {
      /* Selling price — BLACK, formatted */
      var ccPrice = priceWrap.querySelector('.ccPrice, .regularPrice, .focused-price');
      if (ccPrice) {
        /* Update the inner .money span if present, else the element itself */
        var moneySpan = ccPrice.querySelector('.money');
        if (moneySpan) {
          moneySpan.textContent = formattedSP;
        } else {
          ccPrice.textContent = formattedSP;
        }
        ccPrice.style.color = '';
      }

      /* MRP strikethrough — formatted */
      var origPrice = priceWrap.querySelector('.grid-product__price--original');
      if (origPrice) {
        if (cleanCompare) {
          var origMoney = origPrice.querySelector('.money');
          if (origMoney) {
            origMoney.textContent = formattedMRP;
          } else {
            origPrice.textContent = formattedMRP;
          }
          origPrice.style.display = '';
        } else {
          origPrice.style.display = 'none';
        }
      }

      /* Discount badge — recalculate % and update text */
      var savingsBadge = priceWrap.querySelector('.grid-product__price--savings');
      if (savingsBadge) {
        if (cleanCompare) {
          var discountPct = calcDiscount(cleanPrice, cleanCompare);
          if (discountPct) {
            savingsBadge.textContent = discountPct;
            savingsBadge.style.display = '';
          } else {
            savingsBadge.style.display = 'none';
          }
        } else {
          savingsBadge.style.display = 'none';
        }
      }
    }

    /* Card link */
    var link = card.querySelector('.grid-product__link');
    if (link && data.url) link.href = data.url;

    /* Sold out tag */
    var soldOut = card.querySelector('.grid-product__tag--sold-out');
    if (soldOut) soldOut.style.display = data.available === 'true' ? 'none' : '';
  }

  function initSwatchGroup(container) {
    var swatches = Array.from(container.querySelectorAll('[data-rr-swatch-url]'));
    var moreBtn  = container.querySelector('[data-rr-cv-more]');
    var lessBtn  = container.querySelector('[data-rr-cv-less]');
    var hiddenSw = Array.from(container.querySelectorAll('.rr-cv-swatch--hidden:not([data-rr-cv-less])'));
    var scrollHandler = null;

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var card = findCardEl(btn);
        if (card) {
          updateCard(card, {
            url:       btn.dataset.rrSwatchUrl,
            img:       btn.dataset.rrSwatchImg,
            imgHover:  btn.dataset.rrSwatchImgHover,
            title:     btn.dataset.rrSwatchTitle,
            price:     btn.dataset.rrSwatchPrice,
            compare:   btn.dataset.rrSwatchCompare,
            available: btn.dataset.rrSwatchAvailable
          });
        }

        swatches.forEach(function (s) { s.classList.remove('rr-cv-swatch--active'); });
        btn.classList.add('rr-cv-swatch--active');
      });
    });

    function expand() {
      hiddenSw.forEach(function (s) { s.classList.remove('rr-cv-swatch--hidden'); });
      if (moreBtn) moreBtn.classList.add('rr-cv-swatch--hidden');
      if (lessBtn) lessBtn.classList.remove('rr-cv-swatch--hidden');
      var scrollCount = 0;
      scrollHandler = function () {
        scrollCount++;
        if (scrollCount >= 2) collapse();
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }

    function collapse() {
      hiddenSw.forEach(function (s) { s.classList.add('rr-cv-swatch--hidden'); });
      if (moreBtn) moreBtn.classList.remove('rr-cv-swatch--hidden');
      if (lessBtn) lessBtn.classList.add('rr-cv-swatch--hidden');
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        expand();
      });
    }
    if (lessBtn) {
      lessBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        collapse();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-rr-cv]').forEach(initSwatchGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
